export default __webpack_public_path__ + "static/ksiegowosc-dff4fdec63c9255fbba6f76b89a64c2d.jpeg";